<template>
  <div class="tw-flex tw-justify-start tw-text-gray-dark dark:tw-text-dm-gray-dark tw-px-6 tw-gap-6 tw-mb-3">
    <ForeignersListHeaderColumn
      v-for="column in columns"
      :key="column.prop"
      :prop="column.prop"
      :title="column.title"
      :style="`width: ${column.width}`"
    />
  </div>
</template>

<script>
import ForeignersListHeaderColumn from '@/components/Foreigners/List/ForeignersListHeaderColumn.vue';

export default {
  components: {
    ForeignersListHeaderColumn,
  },
  data() {
    return {
      columns: [
        {
          prop: 'fullname',
          title: this.$t('common.fields.first_name'),
          width: '17.16%',
        },
        {
          prop: 'citizenship',
          title: this.$t('common.fields.citizenship'),
          width: '6%',
        },
        {
          prop: 'main_permit_status',
          title: this.$t('common.filters.status'),
          width: '18.06%',
        },
        {
          prop: 'main_permit_expiration_date',
          title: this.$t('foreigners.filters.expiry_date'),
          width: '7.24%',
        },
        {
          prop: 'main_permit_renewal_date',
          title: this.$t('foreigners.filters.renewal_date'),
          width: '7.24%',
        },
        {
          prop: 'survey_submitted',
          title: 'Q',
          width: '3.62%',
        },
        {
          prop: 'client_company',
          title: this.$t('foreigners.filters.client_company'),
          width: '5.07%',
        },
        {
          prop: 'date_modified',
          title: this.$t('common.fields.last_update'),
          width: '10.73%',
        },
        {
          prop: 'assigned_to',
          title: this.$t('common.fields.assigned_to'),
          width: '9.52%',
        },
      ],
    };
  },
};
</script>
